package app.api

import app.client
import app.model.Project
import app.model.ProjectVariable
import app.model.ProjectWithDependencies
import app.plugin.Routing
import dev.fritz2.core.RootStore
import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import io.ktor.client.request.*
import io.ktor.http.*
import kotlinx.coroutines.Job
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

class ProjectVariablesApi : RootStore<List<ProjectVariable>>(emptyList(), job = Job()) {
    val handler = handle { _, id: String ->
        val projectId = id.toInt()
        client.get(Routing.ProjectVariables.Id(id = projectId)).body<List<ProjectVariable>>()
    }

    val postProjectVariable = handle { projectVariables, request: Routing.ProjectVariables.New.Body ->
        val projectVariable = client.post(
            Routing.ProjectVariables.New()
        ) {
            contentType(ContentType.Application.Json)
            setBody(Json.encodeToString(request))
        }.body<ProjectVariable>()
        projectVariables + projectVariable
    }

    val updateProjectVariable = handle { projectVariables, request: ProjectVariable ->
        val projectVariable = client.put(
            Routing.ProjectVariables.Update()
        ) {
            contentType(ContentType.Application.Json)
            setBody(Json.encodeToString(request))
        }.body<ProjectVariable>()
        projectVariables.map { existing ->
            if (existing.id == projectVariable.id) projectVariable else existing
        }
    }

    val deleteProjectVariable = handle { projects, id: Int ->
        val resp = client.delete(Routing.ProjectVariables.Id(id = id))
        require(resp.status == HttpStatusCode.NoContent)
        projects.filter { it.id != id }
    }
}
